import React, {Component} from 'react';
import 'chart.js/auto';
import {Bar, Line, Doughnut} from 'react-chartjs-2';

// {
//   labels: [],
//   datasets:[
//     {
//     label:'Moyenne',
//     data:[],
//     backgroundColor:[],
//     },
//   ]
// }
export class BarChart extends Component{
  constructor(props){
    super(props);
    this.state = {
      chartData:props.chartData
    }
  }

  static defaultProps = {
    displayTitle:true,
    displayLegend: true,
    legendPosition:'right',
  }

  render(){
    return (
      <div className="chart">
        <Bar
          data={this.state.chartData}
          options={{
            title:{
              display:this.props.displayTitle,
              text:this.props.title,
              fontSize:25
            },
            legend:{
              display:this.props.displayLegend,
              position:this.props.legendPosition
            }
          }}
        />

      </div>
    )
  }
}
export class LineChart extends Component{
  constructor(props){
    super(props);
    this.state = {
      chartData:props.chartData
    }
  }

  static defaultProps = {
    displayTitle:true,
    displayLegend: true,
    legendPosition:'right',
  }

  render(){
    return (
      <div className="chart">
        
        <Line
          data={this.props.chartData}
          options={{
            title:{
              display:this.props.displayTitle,
              text:this.props.title,
              fontSize:25
            },
            legend:{
              display:this.props.displayLegend,
              position:this.props.legendPosition
            }
          }}
        />
      </div>
    )
  }
}
export class DoughnutChart extends Component{
  constructor(props){
    super(props);
    this.state = {
      chartData:props.chartData
    }
  }

  static defaultProps = {
    displayTitle:true,
    displayLegend: true,
    // legendPosition:'right',
  }
 
  render(){
      console.log("CHARTS PROPS", this.props, this.state);
      
    return (
      <div className="chart">
        <Doughnut
          data={this.state.chartData}
          options={{
            plugins: {
              title: {
                  display: this.props.displayTitle,
                  text: this.props.title,
                //   padding: {
                //     top: 10,
                //     bottom: 0
                // }
              },
              legend:{
                display:this.props.displayLegend,
                position:this.props.legendPosition
              },
              // layout: {
              //   padding: {
              //     left: 1000,
              //     right: 1000,
              //     top: 1000,
              //     bottom: 1000,
              //   },
              // }
          }
            // title:{
            //   display:this.props.displayTitle,
            //   text:this.props.title,
            //   fontSize:25
            // },
          }}
          // options={{
          //   title:{
          //     display:this.props.displayTitle,
          //     text:this.props.title,
          //     fontSize:25
          //   },
          //   legend:{
          //     display:this.props.displayLegend,
          //     position:this.props.legendPosition
          //   }
          // }}
        />
      </div>
    )
  }
}